import React, { forwardRef } from 'react';
import FilaTablaTerritorios from './FilaTablaTerritorios';
import { useEleccion } from '../../contexts/eleccionContext';
import { eleccion, level } from '../../resources/constantes.json';
import { AnimatePresence, motion } from 'framer-motion';
import styled from 'styled-components/macro';
import { responsive } from '../../resources/constantes.json';

const TablaTerritorios = forwardRef((props, ref) => {
  const elecInfo = useEleccion();

  const getTerritorios = camaraSeleccionada => {
    let territorios = [];
    const isJal =
      elecInfo.idEleccion === eleccion.jal &&
      (props.ambito?.l === level.municipio || props.ambito?.l === level.comuna);
    territorios = isJal
      ? camaraSeleccionada.mapaganinfo
      : camaraSeleccionada.mapagan;
    return territorios;
  };
  const listaTerritorios = getTerritorios(props.camaraSeleccionada);
  return (
    <AnimatePresence>
      {!props.animating && (
        <Ul
          transition={{
            staggerChildren: 0.1,
          }}
          initial="hide"
          exit="hide"
          animate="show"
          ref={ref}
        >
          <AnimatePresence>
            {listaTerritorios?.map((territorio, i) => {
              return (
                <motion.li
                  key={territorio.amb}
                  transition={{
                    duration: 0.2,
                  }}
                  variants={{
                    show: { opacity: 1, translateX: 0 },
                    hide: { opacity: 0, translateX: 50 },
                  }}
                >
                  <FilaTablaTerritorios
                    hayGanadores={territorio.mesesc > 0}
                    key={i}
                    territorio={territorio}
                  />
                </motion.li>
              );
            })}
          </AnimatePresence>
        </Ul>
      )}
    </AnimatePresence>
  );
});

const Ul = styled(motion.ul)`
  display: grid;
  align-items: stretch;
  row-gap: 1.5rem;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;
  overflow-x: hidden;
  @media screen and (min-width: ${responsive.minWidth.desktop}px) {
    padding-left: 1rem;
  }
`;

export default TablaTerritorios;
